import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { SvgIconProps } from '@material-ui/core';
import classNames from 'classnames';

interface IIconProps extends SvgIconProps {
  onClick?: () => void;
}

interface IProps {
  iconProps?: IIconProps;
}

const useStyles = makeStyles({
  deleteIcon: {
    transform: 'rotate(45deg)',
  },
});

const DeleteIcon: FC<IProps> = ({ iconProps }) => {
  const classes = useStyles();

  return (
    <AddCircleIcon
      {...iconProps}
      className={classNames(classes.deleteIcon, iconProps.className)}
      onClick={iconProps.onClick}
    />
  );
};

DeleteIcon.defaultProps = {
  iconProps: {},
};

export default DeleteIcon;
